import { Component, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { Subscription } from 'rxjs';
import { uniqBy } from 'lodash';
import { User } from '../../user/user';
import { UserStorage } from '../../user/user-storage';
import { Acknowledgement, Readable } from '../../view-history';

@Component({
    selector: 'view-history-cell',
    template: require('./view-history-ag-renderer.component.html'),
    styles: [require('./view-history-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewHistoryAgRendererComponent implements AgRendererComponent, OnDestroy {

    public get history() {
        return this.viewHistory;
    }

    public get readByMe() {
        return this.viewHistory ? !!(this.viewHistory.find(h => h.user.sitelinkUserId === this.currentUser.metadata.sitelinkUserId)) : false;
    }

    public get readByOthers() {
        return !this.readByMe && this.viewHistory.length > 0;
    }

    private subscription: Subscription;
    private currentUser: User;
    private viewHistory: Acknowledgement[] = [];

    constructor(private userStorage: UserStorage, private changeDetectorRef: ChangeDetectorRef) {
    }

    public refresh() {
        return false;
    }

    public agInit(row: { data: Readable }): void {
        if (!row.data) {
            return;
        }

        this.subscription = this.userStorage.currentUser.subscribe(u => {
            this.viewHistory = uniqBy(row.data.viewHistory, h => h.user.sitelinkUserId) || [];
            this.currentUser = u;
            this.changeDetectorRef.markForCheck();
        });
    }

    public ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}